import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Typography } from 'rmwc/Typography';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { ListDivider } from 'rmwc/List';
import * as api from '../../api/api'
import * as actions from '../../actions'
import PaginationComponent from '../PaginationComponent';

import { Button, ButtonIcon } from 'rmwc/Button';
import { TextField, TextFieldIcon } from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'

class LearningResourceList extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
    		totalCount: '',
    		data:{
	      		resourceId: '',
	      		resourceName: '',
	      		resourceLink: '',
	      		roadmapName: '',
	      		competencyName: '',
	      		levelName: '',
	      		trackName: '',
	      		createdAt: '',
	      		imgLink: '',
	      		listingSequence: ''
	    	},
	    	resourceData: [],
	    	itemsPerPage: 10,
				criteria: '',
				searchTerm: '',
				searchResource: false,
				errorMsg: '',
				searchErrorMsg: '',
				searchHit: 0
		};
	}

	componentDidMount() {
		let resourceData = []
		let totalCount
		let fetchResources = `admin/learning_resource/render_all_resources/${1}/${this.state.itemsPerPage}`

		api.getResourceDetails(this.props.user.accessToken, fetchResources)
		.then((result) => {
			if (result.status === 'success'){
				resourceData = result.data
				totalCount = result.total_count
				this.setState({resourceData: resourceData, totalCount: totalCount})
			}
		})
	}

	handleFetchCons = (pageNo) => {
		this.retrieveResources(pageNo,this.state.searchResource, this.state.searchHit)
	}

	retrieveResources = (pageNo,isSearch,searchHit) => {
		let resourceData = []
		let totalCount
		let fetchResources = `admin/learning_resource/render_all_resources/${pageNo}/${this.state.itemsPerPage}`
		let apiInput = {'search_key': this.state.criteria,
			"search_term": this.state.searchTerm,
     	"items_per_page": this.state.itemsPerPage,
     	"page_no": pageNo
    }
    console.log(isSearch)
		if(isSearch) {
			api.searchResources(this.props.user.accessToken, apiInput)
			.then((result) => {
				if (result.status === 'success'){
					resourceData = result.data
					totalCount = result.total_count
					this.setState({resourceData: resourceData, totalCount: totalCount, searchResource: true, searchHit:searchHit})
				}
			})
		}
		else {
			api.getResourceDetails(this.props.user.accessToken, fetchResources).then((result) => {
	      if (result.status === 'success') {
	        resourceData = result.data
					totalCount = result.total_count
					this.setState({resourceData: resourceData, totalCount: totalCount,searchResource: false, searchHit:searchHit})
	      }
	    })
	    .catch((err) => {
	      this.setState({ errorMsg: 'Error in Fetching Details' })
	 		})
		}
	}


	handleSearchCriteriaChange = (e) => {
    this.setState({criteria: e.target.value})
  }

  onInputChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  } 

  handleSearchQuery = (e) => {
  	if(this.state.searchTerm === ''){
  		this.setState({searchErrorMsg: 'Search field should not be empty'})
  		return
  	}
    e.preventDefault()
    let searchHit = this.state.searchHit+1
    this.retrieveResources(1,true, searchHit);
    
  }

  handleClear = (e) => {
    e.preventDefault()
    this.setState({searchTerm: '',criteria: ''})
    this.retrieveResources(1,false,0)
  }

	render() {
		let handleFetchCons = this.handleFetchCons
		let pageComponent
		let searchCriteria = ["name", "custom_id"]

		let tableComponent = (
			<tbody>
	            {this.state.resourceData.map(function(resource){
	            	if (resource.resource_link.length > 0) {
		            	return(
		            		<tr key = {resource.id}>
		            			<td>{resource.count}</td>
		            			<td>{resource.id}</td>
		            			<td>{resource.name}</td>
		            			<td>{resource.custom_id}</td>
		            			<td>{resource.language}</td>
		            			<td>{resource.complexity}</td>
		            			<td>{resource.author}</td>
		            			<td>{resource.taxonomy}</td>
		            			<td>{resource.buzzword}</td>
		            			<td>{resource.level}</td>
		            			<td>{resource.track}</td>
		            			<td>{resource.active}</td>
		            			<td><a href={resource.img_link}>{resource.img_link}</a></td>
		            			<td>{resource.listing_sequence}</td>
		            			<td>{resource.created_at}</td>
		            			<td><a href={resource.resource_link} target="_blank" style={{cursor: 'pointer'}}> View </a></td>
		            		</tr>
		            	)
		            }
		            else {
		            	return(
		            		<tr key = {resource.id}>
		            			<td>{resource.count}</td>
		            			<td>{resource.id}</td>
		            			<td>{resource.name}</td>
		            			<td>{resource.custom_id}</td>
		            			<td>{resource.language}</td>
		            			<td>{resource.complexity}</td>
		            			<td>{resource.author}</td>
		            			<td>{resource.taxonomy}</td>
		            			<td>{resource.buzzword}</td>
		            			<td>{resource.level}</td>
		            			<td>{resource.track}</td>
		            			<td>{resource.active}</td>
		            			<td><a href={resource.img_link}>{resource.img_link}</a></td>
		            			<td>{resource.listing_sequence}</td>
		            			<td>{resource.created_at}</td>
		            			<td>NA</td>
		            		</tr>
		            	)
		            }
	            })}
	        </tbody>
	    )
			let paginationKey = this.state.searchHit + this.state.totalCount
	    return(
	    	<div>
		    	<div className="mdc-layout-grid">
					<GridCell span="12">
		                <Card style={{padding: '25px'}}>
		                    <Typography use="headline6">Consolidated Resources View</Typography>
		                </Card>
		            </GridCell>
		        <div>
							<Select 
			          onChange={this.handleSearchCriteriaChange} 
			          value={this.state.criteria}
			          className="admin-reg-filter-section"
			          placeholder="-- Search By Resource --" 
			        >
			        	{searchCriteria.map(criteria => (
			            <option value={criteria} data-name={criteria}>
			              {criteria}
			            </option>
			          ))}
			        </Select>
			        <TextField  className='admin-reg-filter-criteria' label="Search Term" autoComplete="off" name="searchTerm" onChange={this.onInputChange} value={this.state.searchTerm}/>
			        <Button className="add-opportunity" onClick={this.handleSearchQuery}>
			          Search
			        </Button>
			        <Button className="add-opportunity" onClick={this.handleClear}>
			          Clear
			        </Button>
						</div>
						<StatusMessage error_msg = {this.state.searchErrorMsg}/>
			    	<Grid>
		        		<GridCell span="12">
		        			<table>
		        				<th>S.No</th>
		        					<th>Resource ID</th>
					            <th>Resource Name</th>
					            <th>Resource Custom ID </th>
					            <th>Language</th>
					            <th>Complexity</th>
					            <th>Author</th>
					            <th>Aspect(s)</th>
					            <th>Keyword(s)</th>
					            <th>Level</th>
					            <th>Track(s)</th>
					            <th>Active</th>
					            <th>Image Link</th>
					            <th>Listing Sequence</th>
					            <th>Created At</th>
					            <th>Resource Link</th>
					            {tableComponent}
		        			</table>
		        		</GridCell>
		      		</Grid>
		      	</div>
		      	<div key={paginationKey}>
		      		<PaginationComponent totalItems = {this.state.totalCount}
	      				itemsPerPage = {this.state.itemsPerPage} 
	      				onHandleItemsFetch = {handleFetchCons} />
		      	</div>
		      	<StatusMessage error_msg = {this.state.errorMsg}/>
	      	</div>
	    )
	}
}
function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(LearningResourceList);


// WEBPACK FOOTER //
// ./src/views/learning_resource_admin/LearningResourceList.jsx